<template>
<div>
    <div class="objective-modalcontainer">
      <div class="input-group" v-if="editMode">
        <label class="key">Enter the objective :</label>
        <textarea
          class="objective-textarea"
          v-model="tempObjective"
          placeholder="Enter the objective"
        ></textarea>
        <div class="gap-1 flex-end mt-2">
          <button class="btn btn-cancel" @click="$emit('cancel')">Cancel</button>
          <button class="btn" @click="$emit('save', tempObjective)">Add objective</button>
        </div>
      </div>
      <p class="objective-view" v-else>{{ tempObjective || 'No objective defined yet'}}</p>
    </div>
</div>
</template>
<script>
export default {
  name: 'objectiveModal',
  props: {
    objective: {
      type: String,
      default: ''
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tempObjective: this.objective
    }
  }
}

</script>
<style lang="scss" scoped>
.objective{
  &-modalcontainer{
    width: 600px;
    height: fit-content;
  }
  &-view{
    padding: 10px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    min-height: 100px;
    max-height: 200px;
    overflow-y: auto;
    word-break: break-all;
  }
}
/* Phones (up to 480px) */
@media (max-width: 480px) {
.objective-modalcontainer {
  max-width: 85vw;
  max-height: 90vh;
}
}

/* Tablets (portrait and small tablets: 481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
.objective-modalcontainer {
  max-width: 85vw;
  max-height:80vh;
}
}

</style>
